import { Button, message, Space } from 'antd';
import React, { startTransition, useEffect, useState } from 'react';
import TableWrap from '../../../../components/TableWrap';
import './index.scss';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../../store';
import { useNavigate } from 'react-router-dom';
import ModalDelete from '../../../../components/Modal/ModalDelete';
import _ from 'lodash';
import { deleteLifehack, getAllLifehacks } from '../../../../store/lifehack/lifehackSlice';
import { LifehackInterface } from '../../../../interface/lifehack';

const LifeHack: React.FC = () => {
  const lifehackSlice = useSelector((state: RootState) => state.lifehack);
  const { data, loading } = lifehackSlice;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<LifehackInterface>();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  useEffect(() => {
    try {
      dispatch(getAllLifehacks());
    } catch (error) {
      console.log(`${error}`);
    }
  }, [dispatch]);

  const handleEdit = (record) => {
    startTransition(() => {
      navigate(`/life-hack/${record.id}`);
    });
  };
  const showDeleteModal = (record: any) => {
    setSelectedRecord(record as LifehackInterface);
    setIsModalOpen(true);
  };

  const handleDelete = async () => {
    if (selectedRecord) {
      try {
        const result = await dispatch(deleteLifehack({ id: selectedRecord.id }));
        if (result.meta.requestStatus === 'fulfilled') {
          message.success('削除が成功しました!');
          dispatch(getAllLifehacks());
        } else {
          message.error('削除に失敗しました。もう一度お試しください。');
        }
      } catch (error) {
        message.error('削除中にエラーが発生しました。');
      } finally {
        setIsModalOpen(false);
      }
    }
  };

  const columns = [
    {
      title: '投稿名',
      dataIndex: 'keyword',
      key: 'keyword',
      render: (text: string) => <span>{text}</span>,
    },
    {
      title: '画像',
      dataIndex: 'image',
      key: 'image',
      render: (image: string) => (
        <img
          src={`${process.env.REACT_APP_API_URL}${image}`}
          alt="Post"
          style={{ width: '192px', height: '144px', borderRadius: '4px', objectFit: 'cover' }}
        />
      ),
    },
    {
      title: '表示可能',
      dataIndex: 'visibility',
      key: 'visibility',
      render: (visibility: string) =>
        visibility === 'true' ? (
          <span style={{ color: '#34C759' }}>出版済み</span>
        ) : (
          <span style={{ color: 'red' }}>プライバシー</span>
        ),
    },
    {
      title: '',
      key: 'action',
      align: 'center' as const,
      render: (_: any, record) => (
        <Space size="middle">
          <Button
            type="link"
            icon={
              <img src={`${process.env.PUBLIC_URL}/assets/icons/edit.png`} alt="Edit Logo" className="icon-table" />
            }
            onClick={() => handleEdit(record)}
          />
          <Button
            type="link"
            icon={
              <img src={`${process.env.PUBLIC_URL}/assets/icons/delete.png`} alt="Delete Logo" className="icon-table" />
            }
            danger
            onClick={() => showDeleteModal(record)}
          />
        </Space>
      ),
    },
  ];
  const addLearning = () => {
    startTransition(() => {
      navigate(`/life-hack/create`);
    });
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <div>
      <div className="post-management-header">
        <Button className="btn-black" type="primary" onClick={addLearning}>
          新作成
        </Button>
      </div>
      <div className="answer-list-container answer-list">
        <TableWrap
          columns={columns}
          data={_.sortBy(data, 'page').slice((currentPage - 1) * pageSize, currentPage * pageSize)}
          isLoading={loading}
          total={data.length}
          page={currentPage}
          size={pageSize}
          setPage={(page) => setCurrentPage(page)}
          setSize={(newPageSize) => {
            setPageSize(newPageSize);
            setCurrentPage(1);
          }}
        />
      </div>
      <ModalDelete
        isOpen={isModalOpen}
        onOk={handleDelete}
        onCancel={handleCancel}
        content="「質問セット」を削除してもよろしいですか？"
      />
    </div>
  );
};
export default LifeHack;
